<template>
  <div class="text-body-large mb-4">
    {{ label }}
  </div>
  <v-checkbox
    v-for="option in options"
    :key="option.value"
    v-model="selected"
    class="text-font"
    :class="[realSpacing]"
    :label="option.text"
    :value="option.value"
  />
</template>

<script setup lang="ts">
import type { AxiosError } from 'axios';
import axios from 'axios';
import { computed, ref } from 'vue';
import { useDisplay } from 'vuetify';
import { useErrorStore } from '@/stores/errors';

const props = withDefaults(defineProps<{
  indexRoute: string;
  label?: string;
  valueKey?: string;
  textKey?: Array<TextKey>;
  spacing?: string;
  mobileSpacing?: string;
}>(), {
  valueKey: () => 'id',
  textKey: () => [['name', '']],
  spacing: 'mb-n3',
  mobileSpacing: 'mb-3',
});
const { smAndUp } = useDisplay();
const realSpacing = computed(() => {
  return smAndUp.value ? props.spacing : props.mobileSpacing;
});
const { showSnackMessage } = useErrorStore();

const loadingData = ref(0);
const options = ref<any>([]);
const selected = defineModel<any>({ default: [] });

type TextKey = Array<string>;
async function fetchOptions() {
  loadingData.value += 1;
  try {
    const response = await axios.get(`${props.indexRoute}`);
    options.value = response.data.data.map((el) => ({
      value: el[props.valueKey],
      text: props.textKey.reduce((previous, current) => previous + el[current[0]] + current[1], ''),
    }));
  }
  catch (error) {
    const errors = error as Error | AxiosError;
    if (axios.isAxiosError(errors)) {
      showSnackMessage(errors?.response?.data?.message);
    }
  }
  finally {
    loadingData.value -= 1;
  }
}

fetchOptions();
</script>
